import styled, {css} from 'styled-components'

import {media} from '@/src/config/theme'

import * as ProductUI from '@/src/features/catalog/product-list/product-list-item.styled'

export const AddFavouriteBtn = styled.button<{$visible?: boolean}>`
  z-index: 10;

  position: absolute;

  vertical-align: middle;

  top: 30px;
  right: 26px;

  font-size: 0;
  width: 24px;
  height: 24px;
  margin-left: 10px;
  margin-bottom: 5px;
  background: transparent;

  ${ProductUI.MobileActions} & {
    position: relative;
    top: unset;
    right: unset;
  }

  ${ProductUI.ProductFooter} ${ProductUI.ProductActions} & {
    display: block;
    margin: unset;

    @media ${media.lg} {
      position: relative;
      top: unset;
      right: unset;
    }
  }

  svg {
    transition: all ease 0.3s;
  }

  @media ${media.lg} {
    ${props =>
      (!props.$visible &&
        css`
          ${ProductUI.ProductListItem}:hover & {
            display: inline-block;
          }
        `) ||
      css`
        ${ProductUI.ProductListItem} & {
          display: inline-block;
        }
      `}
    ${ProductUI.ProductFooter} ${ProductUI.ProductActions} & {
      display: none;
    }
  }
`
